import AxiosApiInstance, {APIBase} from "../../../../AxiosApiInstance";
import {AxiosResponse} from "axios";

const ApiBackCampaignsConfigsTracksIdDelete
  = (id: string, campaign_pk: string)
  :Promise<AxiosResponse> => {
    return AxiosApiInstance.delete(`${APIBase}back/campaigns/${campaign_pk}/configs/tracks/${id}/`);
  };

export default ApiBackCampaignsConfigsTracksIdDelete;